import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useUIStore } from '@/store/uiStore';
import { useAuthStore } from '@/store/authStore';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

/**
 * 메인 레이아웃
 * - 단일 세로 스크롤(window) 구조
 * - 헤더: fixed top-0 h-16
 * - 사이드바: fixed top-16 (데스크톱 토글 폭, 모바일 드로어)
 * - 메인: pt-16 + 사이드바 폭만큼 좌측 마진
 */
export function MainLayout() {
  const { isSidebarOpen, isMobile, setMobile, setSidebarState } = useUIStore();
  const { isAuthenticated } = useAuthStore();

  // 반응형 브레이크포인트 감지 (lg 미만에서 모바일 모드)
  useEffect(() => {
    const handleResize = () => {
      setMobile(window.innerWidth < 1024);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [setMobile]);

  if (!isAuthenticated) {
    if (typeof window !== 'undefined') {
      window.location.href = '/login';
    }
    return null;
  }

  // 메인의 좌측 마진: 모바일 0 / 데스크톱 토글 상태에 따라 16 또는 64
  const mainMarginClass = isMobile
    ? 'ml-0'
    : isSidebarOpen
      ? 'ml-64'
      : 'ml-16';

  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      <Header />
      <Sidebar />

      <main
        className={`flex-1 pt-16 transition-[margin] duration-300 ease-in-out ${mainMarginClass}`}
      >
        <div className="min-w-0-safe px-4 py-4 sm:px-5 sm:py-5 lg:px-6 lg:py-6">
          <Outlet />
        </div>
      </main>

      {isMobile && isSidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black bg-opacity-50"
          onClick={() => setSidebarState('collapsed')}
          aria-hidden
        />
      )}
    </div>
  );
}
